<div class="dynamic-form" [ngSwitch]="activePage">
    <div *ngSwitchCase="PAGES.MAIN_START">
        <div class="modal-body">
            <cm-display-html class="step-description" [content]="step.description"></cm-display-html>
            <cm-evidence-requirements class="info-section" [step]="step"></cm-evidence-requirements>
            <cm-uploaded-documents
                [maxSize]="fileUploadSettings.maxSize"
                *ngIf="isStepSubmitted"
                class="info-section"
                [step]="step"
            >
            </cm-uploaded-documents>
            <cm-step-on-behalf-list
                *ngIf="step.on_behalf_indicator"
                class="info-section"
                [onBehalfIndicator]="step.on_behalf_indicator"
            >
            </cm-step-on-behalf-list>
        </div>
        <div class="modal-footer">
            <button
                *ngIf="isPendingVerificationStatus && workflowTypeId === WORKFLOW_MODULE_ID.CREDENTIAL"
                type="button"
                class="btn btn-default"
                (click)="onScreenChange({ page: PAGES.RESET_CONFIRM, toggleMode: true })"
            >
                RESET
            </button>
            <button *ngIf="!isStepSubmitted" type="button" class="btn btn-default" (click)="dismissModal()">
                CLOSE
            </button>
            <button
                *ngIf="!isStepSubmitted"
                [disabled]="step?._userActionsDisabled"
                type="button"
                class="btn btn-primary"
                (click)="goToPage(this.PAGES.UPLOAD_START)"
            >
                Continue
            </button>
            <button *ngIf="isStepSubmitted" type="button" class="btn btn-primary" (click)="dismissModal()">
                CLOSE
            </button>
        </div>
    </div>
    <div *ngSwitchCase="PAGES.UPLOAD_START">
        <div class="modal-body">
            <cm-display-html class="step-description" [content]="step.description"></cm-display-html>
            <cm-evidence-requirements [step]="step"></cm-evidence-requirements>
            <div class="upload-label">Upload document(s)</div>
            <div class="separator"></div>
            <cm-file-upload
                class="evidence-file-uploader"
                [maxSize]="fileUploadSettings.maxSize"
                [files]="files"
                (change)="onFilesChange($event)"
            >
            </cm-file-upload>
            <div *ngIf="errorText" class="step-error">{{ errorText }}</div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="dismissModal()">CLOSE</button>
            <button type="button" class="btn btn-primary" (click)="confirmUpload()">Upload</button>
        </div>
    </div>
    <div *ngSwitchCase="PAGES.UPLOAD_CONFIRM">
        <div class="modal-body"><cm-confirm-info [info]="uploadInfo"></cm-confirm-info></div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="backToPreviousPage()">Back</button>
            <button type="button" class="btn btn-primary" (click)="uploadFiles()">Confirm</button>
        </div>
    </div>
    <cm-reset-confirm-content
        *ngSwitchCase="PAGES.RESET_CONFIRM"
        (cancel)="backToPreviousPage()"
        (confirm)="onResetConfirm()"
    >
    </cm-reset-confirm-content>
</div>
